// utility function to generate standard deviation and zero any negative values\

import { round } from "lodash"

export function applyStandardDeviation1SD(avg: number, stddev: number): number[] {
  const performZero = avg <= stddev
  return performZero ? [0, round(avg + stddev, 2)] : [round(avg - stddev, 2), round(avg + stddev, 2)]
}

//
export function applyStandardDeviationpoint5SD(avg: number, stddev: number):number [] {
  const performZero = avg <= stddev
  return  performZero ? [0, round(avg + (0.5 * stddev),2)] : [round (avg - 0.5 * stddev,2),round(avg + 0.5 * stddev,2)]
    

}
// 2sd is not included
//export function applyStandardDeviation2SD(avg: number, stddev: number):number [] {
 // const performZero = avg <= stddev
//  return performZero ? [0, round(avg + 2 * stddev,2)] : [round (avg - 2 * stddev,2),round(avg + 2 * stddev,2)]
    //}
